module.exports = __webpack_public_path__ + "media/images/icons/dotted-separator-be5bbac300e3566148c87a31fb49bd45.svg";